import axios from 'axios'
import Cookies from 'js-cookie'
import { verifyAuthenticatedUser } from 'src/util/verifyAuthenticatedUser'
import { API_KEY_LINX } from '../util/config'
import * as Linx from '../util/Linx'
import { verifyIfIsInMaintenance } from '../util/verifyIsInMaintenance'
import { autenticado, getToken, logout } from './auth'
import { ProductsSortingKey } from 'src/util/enums/products-sorting-key'

export const headers = {
  canal: 'gazin-ecommerce',
  'Access-Control-Allow-Origin': '*',
  'Access-Control-Allow-Headers': '*',
}

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URI,
  headers: { ...headers },
})
export default api

export const apiV2 = axios.create({
  baseURL: process.env.REACT_APP_API_URI_V2,
  headers: { ...headers },
})

apiV2.interceptors.request.use(function (config) {
  if (typeof window !== 'undefined' && autenticado()) {
    config.headers.authorization = `Bearer ${getToken()}`
  }
  return config
})

apiV2.interceptors.response.use(
  (response) => response,
  (error) => verifyAuthenticatedUser(error)
)

apiV2.interceptors.response.use(
  (response) => response,
  (error) => verifyIfIsInMaintenance(error)
)

api.interceptors.response.use(
  (response) => response,
  (error) => verifyIfIsInMaintenance(error)
)

export async function buscaConteudoProduto(id, cor) {
  return fetch(
    `${process.env.REACT_APP_API_URI}/canais/produtos/${id}${
      cor ? `?cor=${cor}` : ''
    }`,
    {
      headers,
    }
  )
    .then((response) => response)
    .catch((error) => verifyIfIsInMaintenance(error))
}

export async function buscaFichaTecnica(id) {
  const resposta = await fetch(
    `${process.env.REACT_APP_API_URI}/canais/produtos/${id}/informacoes`,
    {
      headers,
    }
  )
    .then((response) => response)
    .catch((error) => verifyIfIsInMaintenance(error))
  const data = await resposta.json()
  return data
}

export async function buscaBannerCategoria(categoria) {
  const resposta = await fetch(
    `${process.env.REACT_APP_API_URI}/canais/banners-categorias/${categoria}`,
    {
      headers,
    }
  )
    .then((response) => response)
    .catch((error) => verifyIfIsInMaintenance(error))
  const data = await resposta.json()
  return data
}

export async function buscaBanners() {
  const resposta = await fetch(
    `${process.env.REACT_APP_API_URI}/canais/banners-areas/slider-home`,
    {
      mode: 'cors',
      headers,
    }
  )
    .then((response) => response)
    .catch((error) => verifyIfIsInMaintenance(error))
  const data = await resposta.json()
  return data
}

export async function buscaBannerPromocao() {
  const resposta = await fetch(
    `${process.env.REACT_APP_API_URI}/canais/banners-areas/promocoes-imperdiveis`,
    {
      mode: 'cors',
      headers,
    }
  )
    .then((response) => response)
    .catch((error) => verifyIfIsInMaintenance(error))
  const data = await resposta.json()
  return data
}

export async function buscaDadosConsumidor(token) {
  const dadosConsumidorResponse = await fetch(
    `${process.env.REACT_APP_API_URI}/canais/consumidores`,
    {
      headers: {
        ...headers,
        authorization: `Bearer ${token}`,
        'Access-Control-Allow-Headers': 'Origin, Content-Type, X-Auth-Token',
      },
    }
  )
    .then((response) => response)
    .catch((error) => verifyIfIsInMaintenance(error))

  const dadosConsumidor = await dadosConsumidorResponse.json()
  return dadosConsumidor
}

export async function buscaProdutos(query) {
  const terms = query.busca ? query.busca[0] : ''
  const filter = query.filtro
  const deviceId = Cookies.get('nav_id') ?? null
  const url = 'https://api.linximpulse.com/engage/search/v3/search?'
  const queryParams = {
    apiKey: API_KEY_LINX,
    terms: encodeURIComponent(terms),
    page: 1,
    resultsPerPage: 20,
    sortBy: ProductsSortingKey.Relevance,
    productFormat: 'complete',
    showOnlyAvailable: false,
    deviceId,
  }
  let filterString = ''

  if (filter) {
    filterString =
      '&filter=' +
      (typeof filter === 'string' ? filter : filter.join('&filter='))
  }
  const completeUrl = url + new URLSearchParams(queryParams) + filterString

  const response = await fetch(completeUrl, {
    headers: {
      origin: Linx.origin(),
    },
  })

  return response ? response.json() : null
}

export async function checkIfConsumerExists(consumer) {
  const checkConsumerExists = await fetch(
    `${process.env.REACT_APP_API_URI}/canais/consumidores/check`,
    {
      method: 'POST',
      mode: 'cors',
      headers: {
        ...headers,
        'Content-Type': 'application/json;charset=utf-8',
      },
      body: JSON.stringify({
        email_cpf: consumer.email ?? consumer.cpf,
      }),
    }
  )
    .then((response) => response)
    .catch((error) => verifyIfIsInMaintenance(error))

  return checkConsumerExists?.status === 404
}

export async function sendBoletoEmail(vendaId, token) {
  return fetch(
    `${process.env.REACT_APP_API_URI}/canais/consumidores/meus-pedidos/${vendaId}/boleto-email`,
    {
      method: 'POST',
      mode: 'cors',
      headers: {
        ...headers,
        authorization: `Bearer ${token}`,
        'Content-Type': 'application/json;charset=utf-8',
      },
    }
  )
}

export async function getBoletoData(vendaId, token) {
  const response = await fetch(
    `${process.env.REACT_APP_API_URI}/canais/consumidores/meus-pedidos/${vendaId}/boleto`,
    {
      method: 'GET',
      mode: 'cors',
      headers: {
        ...headers,
        authorization: `Bearer ${token}`,
        'Content-Type': 'application/json;charset=utf-8',
      },
    }
  )
    .then((response) => response)
    .catch((error) => verifyIfIsInMaintenance(error))

  return response
}

export async function getSacTickets() {
  const resposta = await fetch(
    `${process.env.REACT_APP_API_URI_V2}/canais/sac/tickets`,
    {
      headers: {
        ...headers,
        'Content-Type': 'application/json;charset=utf-8',
        authorization: `Bearer ${getToken()}`,
      },
    }
  )
    .then((response) => response)
    .catch((error) => verifyIfIsInMaintenance(error))
  return await resposta.json()
}

export async function buscaPagina(pagina) {
  const resposta = await fetch(
    `${process.env.REACT_APP_API_URI}/canais/paginas/${pagina}`,
    {
      headers: {
        ...headers,
        'Content-Type': 'application/json;charset=utf-8',
      },
    }
  )
    .then((response) => response)
    .catch((error) => verifyIfIsInMaintenance(error))
  return resposta.json()
}
